import $ from "jquery";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


    
    var downloadrun = false;

    function checkForConfirmationMessage() {
            
        if (!downloadrun) {
            if ($('#gform_confirmation_message_27').length) {
                var titleHtml = '<div class="row-1 m-l-t"><h3>Thank You!</h3></div>';
                var buttonHtml = '<div class="row-1 m-s-t"><a class="btn btn-secondary download-pdf" id="download-pdf">Download Information Pack</a></div>';
                
                console.log('27 found');
                $('#gform_confirmation_message_27').prepend(titleHtml);
                $('#gform_confirmation_message_27').append(buttonHtml);
        
                //$('.contactform_title').text('Thank You');
                //$('.contactform_text').hide();

                $('html, body').stop();
        
                downloadrun = true;

            }

            if ($('#gform_confirmation_message_30').length) {
                var buttonHtml = '<div class="row-1 a-cc m-l-t"><a class="btn btn-secondary download-pdf" id="download-pdf">Download Information Pack</a></div>';
                
                console.log('30 found');

                $('#gform_confirmation_message_30').append(buttonHtml);
        
                $('.contactform_title').text('Thank You');
                $('.contactform_text').hide();

                var target = $('#enquire');

                function scrollDownTo() {
                    $('html, body').stop().animate({
                        scrollTop: target.offset().top
                    }, 1000);
                }
            
                // Set a timeout for 2 seconds (2000 milliseconds)
                setTimeout(scrollDownTo, 1500);


        
                downloadrun = true;

            }


            $('.download-pdf').click(function() {
                var pdfName = $('#post_title').data('posttitle') + " Property Information Pack";
                console.log('download pdf clicked..');
                // Initialize jsPDF
                var doc = new jsPDF({
                  orientation: 'landscape', // or 'landscape'
                  unit: 'mm', // or 'mm' or 'pt'
                  marginLeft: 0, // left margin
                  marginRight: 0, // right margin
                  marginTop: 0, // top margin
                  marginBottom: 0 // bottom margin
              });
              
                // Convert HTML to canvas using html2canvas
                html2canvas($('#print_section')[0], {
                  scale: 2 // Set the scale factor to 2 for double resolution
              }).then(function(canvas) {
                    var imgData = canvas.toDataURL('image/png');
              
                    var width = $('#print_section').width();
                    var height = $('#print_section').height();
                    
                    var aspectRatio = width / height;
                    var height_ratio = 296 / aspectRatio;
                    
                    console.log("Aspect ratio of #print_section: " + aspectRatio);
                    
                    // Add image to PDF
                    doc.addImage(imgData, 'PNG', 0, 0, 296, height_ratio);
            
                    // Save PDF
                    doc.save(pdfName + '.pdf');
                });
              });

        } else {
            //  console.log('#gform_confirmation_message_27 NOT found');
        }
    }
    
    // Check every 2 seconds
    setInterval(checkForConfirmationMessage, 500);






